import { authHeader } from '../_core/auth-header';
import Config from '../_core/config';

import OAuth from 'oauth-1.0a';
import crypto from 'crypto';

export const orderService = {
    getAll,
    getById,
    getAllbyMethod,
    create,
    update,
    createWooCommerceOrder,
    paynamicsService
};

function create(cart) {
    let items = []
    for(let i in cart.items){
        let item = {
            "product": cart.items[i].p,
            "name": cart.items[i].n,
            "slug": cart.items[i].s,
			"sku": cart.items[i].s,
			"model": cart.items[i].s,
            "unit_price": cart.items[i].c,
            "quantity": cart.items[i].q
        }
        items.push(item);
    }

    const order = {
        "id": cart.id,
        "payment_method":"paypal",
        "orderId":"",
        "totalPrice":cart.total,
        "remarks": "cart.remarks",
        "intent": "sale",
        "status": "submitted",
        "firstName":cart.firstName || '',
        "lastName":cart.lastName || '',
        "phone":cart.phone || '',
        "email":cart.email || '',
        "address1":cart.address || '',
        "city":cart.city || '',
        "state":cart.state || '',
        "province":cart.province || '',
        "barangay":cart.barangay || '',
        "country":cart.country || '',
        "zip":cart.zip || '',
        "postal":cart.postal || '',
        "particulars": items
    }
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(order)
    };
    
    return fetch(Config.api.basepath+`/order`, requestOptions).then(handleResponse)
}



// Function to create WooCommerce order
function createWooCommerceOrder(cart, transactionId) {

    const baseUrl = window.location.origin;
    const url = `${baseUrl}/wp-json/wc/v3/orders`;

    // Prepare items array for WooCommerce order
    const items = cart.items.map(item => ({
        product_id: item.id, // Assuming `p` is the product ID
        quantity: item.quantity,
        meta_data: [
            { key: 'name', value: item.name },
            { key: 'slug', value: item.slug },
            { key: 'sku', value: item.sku },
            { key: 'model', value: item.model },
            { key: 'unit_price', value: item.prices.price }
        ]
    }));

    // Calculate total amount
    const totalAmount = cart.total + cart.shippingFee[0].cost;

    // Prepare WooCommerce order data
    const orderData = {
        payment_method: "paynamics",
        payment_method_title: "Paynamics",
        set_paid: false,
        customer_id: cart.id,
        billing: {
            first_name: cart.first_name || '',
            last_name: cart.last_name || '',
            address_1: cart.address_1 || '',
            city: cart.city || '',
            state: cart.state || '',
            postcode: cart.postcode || cart.zip || '',
            barangay: cart.barangay || '',
            country: cart.country || '',
            email: cart.email || '',
            phone: cart.phone || ''
        },
        line_items: items,
        shipping_lines: [
            {
                method_id: cart.shippingFee[0].methodId.toString(), // Convert to string
                method_title: cart.shippingFee[0].title,
                total: cart.shippingFee[0].cost.toString() // Convert to string
            }
        ],
        shipping :{
            first_name: cart.shippingDetails.first_name,
            last_name: cart.shippingDetails.last_name,
            address_1: cart.shippingDetails.address_1,
            address_2: cart.shippingDetails.address_2,
            city: cart.shippingDetails.city,
            state: cart.shippingDetails.state,
            postcode: cart.shippingDetails.postcode,
            country: cart.shippingDetails.country,
            barangay: cart.barangay
        },
        total: totalAmount.toString(), // Convert to string
        customer_note: cart.remarks || '',
        status: "pending",
        meta_data: [
            { key: '_transaction_id', value: transactionId }
        ]
    };

    // Generate OAuth headers
    const oauth = oauthFunction();

    const requestConfig = {
        method: 'POST', // or 'PUT' depending on your API
        headers: {
            'Content-Type': 'application/json',
            ...oauth.toHeader(oauth.authorize({ url, method: 'POST' }))
        },
        body: JSON.stringify(orderData) // Include the updated customer data here
    };

    // Make the API request to create the order
    return fetch(url, requestConfig)
        .then(response => {
            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }
            return response.json();
        })
        .then(data => {
            
            // Notify admin about the new order
            // notifyAdmin(data.id);
            return data;
        })
        .catch(error => {
            console.error('There was an error creating the order:', error);
            throw error;
        });
}


function paynamicsService(orderId, paymentDetails) {
    const baseUrl = window.location.origin;
    const url = `${baseUrl}/wp-json/wc/v3/paynamics/redirect/${orderId}`;

    const requestConfig = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            // Add any additional headers if needed
        },
    };

    return fetch(url, requestConfig)
        .then(response => {
            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }
            return response.json();
        })
        .then(data => {
            //console.log('Paynamics redirection URL received:', data);
            return data;
        })
        .catch(error => {
            console.error('There was an error fetching the Paynamics redirection URL:', error);
            throw error;
        });
}



function getAll(options) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    let url = Config.api.basepath+`/order?`;

    url = options.page ? url + `page=` + options.page : url
    url = options.items ? url + `&per-page=` + options.items : url
    url = options.limit ? url + `&limit=` + options.limit : url;

    let filter = options.filter && Object.keys(options.filter).reduce(function (r, k) {
        return r.concat(k + ':' + options.filter[k]);
    }, []);

    url = options.filter ? url + `&filter=` + filter : url;

    return fetch(url, requestOptions)
        .then(handleResponse)
        .then(
            orders => {
                let pages = parseInt(orders.total / orders['per-page']);
                pages = orders.total > ( pages * orders['per-page'] ) ? pages + 1 : pages;

                orders.pages = pages;

                return orders;
            },
            error => {
                return {error: 'Fetch Products Error. Service Unavailable.'};
            }
        );
}

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(Config.api.basepath+`/order/`+id, requestOptions).then(handleResponse);
}

function update(id, data) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(Config.api.basepath+`/order/`+id, requestOptions).then(handleResponse);
}

function getAllbyMethod(type) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    
    return fetch(Config.api.basepath+`/order?filter=payment_method:` + type, requestOptions).then(handleResponse)  
}


function oauthFunction() {
    
    const oauth = OAuth({
        consumer: {
            key: Config.woocommerce.key,
            secret: Config.woocommerce.secret
        },
        signature_method: 'HMAC-SHA1',
        hash_function(baseString, key) {
            return crypto.createHmac('sha1', key).update(baseString).digest('base64');
        }
    });


    return oauth
}


function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
